import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { PrimaryButton, SecondaryButton } from '@/components';
import { ApiTransactionAPIModelStatusEnum as TransactionAPIModelStatusEnum } from '@/generated/api/fps/core';
import { BlankLayout } from '@/layout';
import { DemoUIState } from '@/model/demo/types';
import { UIState } from '@/model/global/types';
import { actions } from '@/model/withdrawal';
import { makeSelectStep } from '@/model/withdrawal/selectors';
import { WithdrawalStep } from '@/model/withdrawal/types';
import { HistoryOptions } from '@/pages/wallets/components';
import { useResultFields } from '@/pages/withdrawal/hooks';
import { FailedView, ProgressView, SuccessView } from '@/pages/withdrawal/pages/StatusPage/components';

const selectStatus = makeSelectStep();

export const StatusPage: React.FC = () => {
  const history = useHistory();
  const { status, step } = useSelector(selectStatus);
  const transaction = useResultFields();

  if (!transaction) {
    // should never happened
    return <BlankLayout />;
  }
  if (step === WithdrawalStep.Running) {
    return (
      <ProgressView
        transaction={transaction}
        action={
          <SecondaryButton
            title={<FormattedMessage id="demo.pages.result.progress.submit.title" />}
            onClick={(): void => history.push(`${DemoUIState.WALLET}`)}
          />
        }
      />
    );
  }
  if (status === TransactionAPIModelStatusEnum.Finished) {
    return (
      <SuccessView
        basePath={UIState.DEMO}
        transaction={transaction}
        Options={HistoryOptions}
        action={{
          title: <FormattedMessage id="demo.pages.result.success.submit.title" />,
          run: (): void => history.push(`${DemoUIState.WALLET}`),
        }}
      />
    );
  }
  return (
    <FailedView
      transaction={transaction}
      action={
        status === TransactionAPIModelStatusEnum.Cancelled ? (
          <PrimaryButton
            title={<FormattedMessage id="withdrawal.pages.result.failed.submit.title.cancelled" />}
            onClick={(): void => {
              actions.storeStep({});
              history.push(`${DemoUIState.PREPARE}`);
            }}
          />
        ) : (
          <PrimaryButton
            title={<FormattedMessage id="demo.pages.result.failed.submit.title.common" />}
            onClick={(): void => history.push(`${DemoUIState.WALLET}`)}
          />
        )
      }
    />
  );
};

export default StatusPage;
